export const skillLevelMapper = {
    0: 'Trainee',
    1: 'Junior',
    2: 'Semi Senior',
    3: 'Senior',
}
